// English family texts (w4). Same shape as family.nl.ts; the type enforces completeness.
export const familyEn = {
    nav: { wishes: 'Wishes', messages: 'Messages', calendars: 'Calendars', family: 'Family' },
    common: {
        save: 'Save',
        saved: 'Saved.',
        add: 'Add',
        edit: 'Edit',
        remove: 'Remove',
        undo: 'Undo',
        copy: 'Copy link',
        copied: 'Link copied.',
        readOnly: 'Read only',
        everyone: 'Everyone',
        loading: 'Loading…',
        retry: 'Try again',
        error: 'Something went wrong. Please try again.',
        back: 'Back',
        close: 'Close',
        whoAreYou: 'Who are you?',
        readAloud: 'Read aloud',
        inDays: { one: 'tomorrow', other: 'in {count} days' },
        today: 'today',
        turnsAge: 'turns {age}',
        dayOf: 'day {index} of {count}',
    },
    wishes: {
        title: 'Wishes',
        intro: 'What is on the wish lists? Children pick a picture on the tablet themselves.',
        add: 'Add wish',
        addShort: 'Wish',
        listOf: "{name}'s wishes",
        editTitle: 'Edit wish',
        newTitle: 'New wish',
        fieldTitle: 'What is it?',
        fieldTitleHint: 'Short and clear, for example Balance bike',
        fieldFor: 'For',
        fieldPicto: 'Picture',
        fieldNote: 'Note',
        fieldNoteHint: 'Size, colour or brand (optional)',
        fieldUrl: 'Shop link',
        fieldUrlHint: 'Starts with https:// (optional)',
        fieldPrice: 'About (€)',
        fieldPriority: 'How much?',
        priority1: 'Nice',
        priority2: 'Really nice',
        priority3: 'Most wanted',
        received: 'Received',
        markReceived: 'Received',
        fromTablet: 'picked on the tablet: choose the exact one together',
        removed: '{title} removed.',
        receivedToast: '{title} moved to received.',
        share: 'Share',
        shareTitle: "Share {name}'s list",
        shareIntro: 'Anyone with this link can see the list and tick something off, no account needed. {name} never sees who buys what.',
        shareCreate: 'Create a share link',
        shareNew: 'New link',
        shareNewHint: 'The old link stops working.',
        shareStop: 'Stop sharing',
        shareStopped: 'The list is no longer shared.',
        shared: 'Shared',
        reveal: 'Reveal',
        revealHint: 'Show what has been bought. Careful: children may be watching.',
        claimedBy: '{name} is buying this',
        claimedAnon: 'Someone is buying this',
        boughtBy: '{name} bought it',
        boughtAnon: 'Already bought',
        emptyTitle: 'No wishes yet',
        emptyBody: 'Add one, or let {name} pick one on the tablet.',
        urlInvalid: 'Use a link that starts with https://',
    },
    share: {
        title: "{name}'s wish list",
        intro: 'Pick something to give. {name} does not see who buys what.',
        claim: "I'll buy this",
        claimTitle: 'Give this gift',
        claimName: 'Your name (optional)',
        claimNameHint: 'So others can see it is taken care of.',
        claimConfirm: "I'll buy this",
        mine: 'You are buying this',
        mineBought: 'You bought this',
        bought: 'Bought',
        release: 'Never mind',
        taken: 'Someone is already buying this',
        takenBy: '{name} is already buying this',
        goneTitle: 'This link no longer works',
        goneBody: 'Ask for a new link.',
        emptyTitle: 'The list is still empty',
        emptyBody: 'Check back later.',
        footer: 'Made with the AMUMIN family board. No account needed.',
        toWebshop: 'View in shop',
    },
    days: {
        title: 'Calendars',
        intro: 'Birthdays, holidays, school holidays and linked calendars appear in the calendar automatically.',
        upcoming: 'Coming up',
        upcomingEmpty: 'Nothing special in the coming weeks.',
        layers: 'What shows in the calendar?',
        layerBirthdays: 'Birthdays',
        layerBirthdaysHint: 'Of the family and of families who share their birthdays.',
        layerHolidays: 'Public holidays',
        layerHolidaysHint: "King's Day, Easter, Christmas and days like Mother's Day.",
        layerSchool: 'School holidays',
        region: 'Region',
        regionNoord: 'North',
        regionMidden: 'Middle',
        regionZuid: 'South',
        regionOff: 'Off',
        regionHint: 'Which region is your school in? Autumn, Christmas, spring and May are advisory dates.',
        birthdays: 'Birthdays',
        birthdaysHint: 'Enter a date of birth and the birthday appears in the calendar.',
        birthDate: "{name}'s date of birth",
        birthDateSaved: "{name}'s birthday is in the calendar.",
    },
    feeds: {
        title: 'Linked calendars',
        add: 'Link a calendar',
        addTitle: 'Link a calendar',
        intro: 'Bring in school, sports and work automatically. Updated every half hour.',
        provider: 'Where does the calendar come from?',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'Other',
        },
        howto: {
            google: 'Calendar settings → Integrate calendar → Secret address in iCal format.',
            icloud: 'Calendar → share calendar → Public calendar → copy the webcal link.',
            outlook: 'Settings → Calendar → Shared calendars → Publish → ICS link.',
            parro: 'Parro → Settings → Link calendar → copy the link.',
            magister: 'Magister → Calendar → Share calendar → copy the link.',
            sportlink: 'Voetbal.nl → Programme → Add to calendar → copy the iCal link.',
            other: 'Any link ending in .ics or starting with webcal:// works.',
        },
        url: 'Link',
        urlHint: 'Starts with webcal:// or https://',
        name: 'Name',
        namePlaceholder: 'For example School',
        forWho: 'For',
        forWhoHint: 'Nobody selected = everyone.',
        review: 'Show unknown items first',
        reviewHint: 'Useful for one school calendar with several children.',
        rules: 'Rules',
        rulesHint: 'Is this in the title? Then it belongs to…',
        ruleContains: 'Text',
        rulePlaceholder: 'for example year 3',
        addRule: 'Add rule',
        connect: 'Link',
        connected: '{name} is linked: {count} events.',
        refresh: 'Refresh now',
        refreshed: 'Updated.',
        remove: 'Unlink',
        removeConfirm: 'Unlink calendar {name}? Its events disappear from your calendar.',
        removed: '{name} was unlinked.',
        statusOk: 'Updated {ago}',
        statusNew: 'Not fetched yet',
        statusStale: 'Out of date: unreachable for a day',
        statusError: 'Did not work: {error}',
        items: { one: '{count} event', other: '{count} events' },
        reviewCount: 'Unknown ({count})',
        reviewTitle: 'Who is this for?',
        reviewIntro: 'Choose who each event is for. It stays that way, even after refreshing.',
        hide: 'Hide',
        assign: 'Assign',
        readonlyNote: 'Title and time come from the linked calendar.',
        emptyTitle: 'No calendar linked yet',
        emptyBody: 'Bring in school, sports and work automatically.',
    },
    links: {
        title: 'Family and friends',
        intro: 'Link grandparents, the other parent or friends. You choose what you share.',
        add: 'Link family',
        addTitle: 'Link family',
        codeHave: 'Got a code?',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'View',
        kind: 'Who is it?',
        kinds: {
            grandparents: 'Grandparents',
            coparent: 'Other parent',
            family: 'Family',
            friends: 'Friends',
        },
        label: 'What do you call them?',
        labelPlaceholder: 'For example Grandma and Grandpa',
        via: 'How to invite?',
        viaEmail: 'By e-mail',
        viaCode: 'With a code',
        email: 'E-mail address',
        share: 'What do you share?',
        scopeAgenda: 'Calendar of',
        scopeAgendaHint: 'Only the events of the children you choose.',
        scopeBirthdays: 'Birthdays',
        scopeWishlists: 'Wish lists',
        scopeContact: 'Contact details',
        scopeMessages: 'Messages',
        scopeMessagesHint: 'They can join conversations you add them to.',
        invite: 'Invite',
        invited: 'Invitation sent to {email}.',
        codeReady: 'Give this code to {label}',
        codeValid: 'Valid until {date}. They enter it at Family → Got a code?',
        weShare: 'We share',
        theyShare: 'They share',
        nothing: 'nothing yet',
        statusPending: 'invited',
        statusActive: 'linked',
        statusRevoked: 'unlinked',
        statusEnded: 'unlinked by them',
        expires: 'expires {date}',
        view: 'View',
        adjust: 'Adjust',
        revoke: 'Unlink',
        revokeInvite: 'Withdraw',
        remove: 'Remove',
        guestMoreDays: 'Show {count} more days',
        endedHint: 'They stopped the link. Remove it here; you can always link again.',
        revokeConfirm: 'Unlink {label}? You will no longer see anything of each other.',
        revoked: 'Link removed.',
        previewTitle: '{name} wants to link',
        previewShares: 'They share with you:',
        accept: 'Link',
        accepted: 'Linked with {name}. Choose below what you share back.',
        acceptLabel: 'What do you call them?',
        inviteGone: 'This invitation does not exist (any more) or was already used.',
        linkGoneTitle: 'This link no longer works',
        linkGoneBody: 'Ask for a new code, or enter it below.',
        toFamily: 'Go to Family',
        emailMismatch: 'This invitation is for a different e-mail address.',
        alreadyLinked: 'You are already linked.',
        contactTitle: 'Our contact card',
        contactHint: 'Only visible to families you share contact details with.',
        address: 'Address',
        phone: 'Phone',
        contactEmail: 'E-mail',
        note: 'Note',
        emptyTitle: 'Nobody linked yet',
        emptyBody: 'Link the grandparents: they see birthdays and wishes, and can send messages.',
        guestTitle: '{name}',
        guestNothing: 'Nothing shared yet',
        guestNothingBody: 'They choose what they show.',
        guestAgenda: 'Calendar (14 days)',
        guestBirthdays: 'Birthdays coming up',
        guestWishes: 'Wishes',
        guestContact: 'Contact',
        guestNoEvents: 'No events in the next two weeks.',
    },
    messages: {
        title: 'Messages',
        intro: 'Safe: only the family and families you link. No ads, no algorithms.',
        parentsReadAll: 'Parents can read every conversation, including the children’s.',
        family: 'Family',
        add: 'Conversation',
        addTitle: 'New conversation',
        fieldTitle: 'Conversation name',
        fieldTitlePlaceholder: 'For example Grandma and Grandpa',
        fieldWho: 'Who joins?',
        fieldLinks: 'Linked families',
        fieldLinksHint: 'Only families you share messages with.',
        create: 'Create conversation',
        placeholder: 'Write a message…',
        send: 'Send',
        stickers: 'Stickers',
        record: 'Record',
        recording: 'Recording… tap to stop',
        voice: 'Voice message',
        play: 'Play',
        hidden: 'Message hidden by a parent',
        hide: 'Hide',
        fromLinked: 'From linked families',
        pickConversation: 'Pick a conversation',
        emptyTitle: 'No messages yet',
        emptyBody: 'Start in the family conversation.',
        kidEmptyBody: 'Send a sticker!',
        newMessages: 'new messages',
        noMember: 'Link your login to a family member first to send messages.',
        sticker: 'Sticker',
    },
    phrase: {
        love: 'I love you',
        comeHome: 'Are you coming home?',
        hungry: "I'm hungry",
        done: 'Done!',
        miss: 'I miss you',
        play: 'Come and play?',
    },
    wishPicto: {
        gift: 'Present',
        play: 'Cuddly toy',
        puzzle: 'Puzzle',
        drawing: 'Drawing set',
        crafts: 'Craft set',
        reading: 'Book',
        gaming: 'Game console',
        cycling: 'Bike',
        soccer: 'Football',
        skating: 'Skates',
        swimming: 'Swim gear',
        dance: 'Dance class',
        'music-lesson': 'Music lesson',
        guitar: 'Guitar',
        piano: 'Piano',
        drums: 'Drum kit',
        unicorn: 'Unicorn',
        dino: 'Dinosaur',
        rocket: 'Rocket',
        bear: 'Bear',
        rabbit: 'Rabbit',
        cat: 'Cat',
        dolphin: 'Dolphin',
        butterfly: 'Butterfly',
        rainbow: 'Rainbow',
        sunflower: 'Flowers',
        'ice-cream': 'Ice cream',
        pizza: 'Pizza',
        popcorn: 'Popcorn',
        cinema: 'Cinema trip',
        zoo: 'Zoo trip',
        museum: 'Museum trip',
        camping: 'Camping',
        sleepover: 'Sleepover',
        party: 'Party',
        trophy: 'Trophy',
    },
    kiosk: {
        wishesEntry: 'Wishes',
        messagesEntry: 'Messages',
        myWishes: 'My wishes',
        newWish: 'New wish',
        pickPicture: 'Pick a picture',
        howMuch: 'How much do you want it?',
        addToList: 'On my list',
        removeAsk: 'Remove?',
        wishAdded: 'It is on your list!',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'It is on your list',
        noWishes: 'No wishes yet',
        noWishesBody: 'Tap the plus and pick a picture.',
        conversations: 'Conversations',
        unread: { one: '{count} new', other: '{count} new' },
        wishRemoved: '{title} is gone',
        messageSent: 'Sent',
        oops: 'Oops',
        typeOwn: 'Type',
        typeLabel: 'Your message',
        typePlaceholder: 'What do you want to say?',
        send: 'Send',
        closeTyping: 'Done typing',
        notYou: 'Not you?',
        newMessages: 'New messages',
        alreadyOnList: 'Already on your list!',
        alreadyOnListCalm: 'Already on your list',
        morePictures: 'More pictures',
        morePhrases: 'More phrases',
    },
};
//# sourceMappingURL=family.en.js.map